import { render, staticRenderFns } from "./Incidents-Results-Card.vue?vue&type=template&id=407f40f6&scoped=true&lang=pug"
import script from "./Incidents-Results-Card.vue?vue&type=script&setup=true&lang=ts"
export * from "./Incidents-Results-Card.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Incidents-Results-Card.vue?vue&type=style&index=0&id=407f40f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407f40f6",
  null
  
)

export default component.exports